import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Badge } from '../ui/badge';

const ProjectCard = ({ project }) => {
  return (
    <div className="group relative bg-slate-900/50 rounded-2xl overflow-hidden border border-slate-800/50 hover:border-emerald-500/30 transition-all duration-500 hover:shadow-2xl hover:shadow-emerald-500/10">
      {/* Image Container */}
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
        
        {/* Type Badge */}
        <div className="absolute top-4 left-4">
          <Badge className="bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 backdrop-blur-sm px-3 py-1 text-xs font-medium">
            {project.type}
          </Badge>
        </div>

        {/* View Details Button - appears on hover */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500">
          <button className="bg-white/10 backdrop-blur-md text-white px-6 py-3 rounded-full flex items-center gap-2 border border-white/20 hover:bg-white/20 transition-all duration-300 transform translate-y-4 group-hover:translate-y-0">
            View Details
            <ArrowUpRight size={16} />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Title */}
        <h3 className="text-xl font-bold text-white mb-3 group-hover:text-emerald-400 transition-colors duration-300">
          {project.title}
        </h3>
        
        {/* Description */}
        <p className="text-slate-400 text-sm leading-relaxed mb-4 line-clamp-3">
          {project.description}
        </p>

        {/* Technologies */}
        <div className="flex flex-wrap gap-2 mb-4">
          {project.technologies.map((tech, index) => (
            <span
              key={index}
              className="text-xs px-3 py-1 rounded-full bg-slate-800/80 text-slate-300 border border-slate-700/50"
            >
              {tech}
            </span>
          ))}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-4 border-t border-slate-800/50">
          <span className="text-xs text-slate-500">{project.category}</span>
          <Badge 
            className={`text-xs px-3 py-1 ${
              project.status === 'Live' 
                ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30' 
                : 'bg-amber-500/20 text-amber-400 border border-amber-500/30'
            }`}
          >
            {project.status}
          </Badge>
        </div>
      </div>

      {/* Hover glow effect */}
      <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-emerald-500/5 via-transparent to-teal-500/5" />
      </div>
    </div>
  );
};

export { ProjectCard };
